module.exports = __webpack_public_path__ + "static/media/10-9.26f7f24d.mp3";